// TODO: Tratar entrada de números negativos
function fromString(entrada) {
    if (typeof entrada !== 'string') {
        return 0;
    }

    const numeros = entrada.replace(/[^0-9.]/g, '');

    if (numeros.length === 0) {
        return 0;
    }

    return parseInt(numeros);
}

export default fromString